require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-139-hourly-progress-v-task-progress.json") })
        }
      }, "path---article-139-hourly-progress-v-task-progress");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-139-hourly-progress-v-task-progress!./.cache/json/article-139-hourly-progress-v-task-progress.json
// module id = 491
// module chunks = 231608221292675